import { FieldKinds } from '@site-mate/dashpivot-shared-library';

import { FormRegisterViewMultiSelectFilterComponent } from 'app/form-fields/common/register/filters/multi-select/form-register-view-multi-select-filter.component';
import { FormRegisterViewMultiSelectListFilterComponent } from 'app/form-fields/common/register/filters/multi-select/form-register-view-multi-select-list-filter.component';
import { FormRegisterViewMultiSelectTableListFilterComponent } from 'app/form-fields/common/register/filters/multi-select/form-register-view-multi-select-table-list-filter.component';

import { MultiSelectFilter } from '../../common/register/filters/multi-select/multi-select-filter';
import { FormFieldHeaderColumn } from '../../common/register/form-field-header/form-field-header-column';

export class CategoryHeaderColumn extends FormFieldHeaderColumn {
  categoryType: string;
  categorySource: string;
  availableItems: any[];
  referenceListId: string;

  constructor(item) {
    super(item);
    this.categoryType = item.categoryItem;
    this.categorySource = item.categorySource;

    if (item.categorySource === 'manual') {
      this.availableItems = item.items.map((ai) => Object.assign(ai, { label: ai.value }));
    } else if (item.categorySource === 'list') {
      this.referenceListId = item.reference;
    }

    this.filter = this.getFilter(item);
  }

  // TODO: this should be moved to separate headers based on the field type
  private getFilter(item) {
    const filterType = {
      static: FormRegisterViewMultiSelectFilterComponent,
      table: FormRegisterViewMultiSelectTableListFilterComponent,
      default: FormRegisterViewMultiSelectListFilterComponent,
    };
    if (item.static) {
      return new MultiSelectFilter(filterType.static);
    }

    if (item.headerKind === FieldKinds.Table) {
      return new MultiSelectFilter(filterType.table, item.fieldId, item.templateId, item._id);
    }

    return new MultiSelectFilter(filterType.default, item._id, item.templateId);
  }
}
